import { useNavigate } from 'react-router';

import { useInboxSummaryQuery } from '@shared/api/inboxSummaryApi';
import { BaseIconButton } from '@shared/components/base';
import { cn } from '@shared/lib/cn';

import { SHELL_TEXT } from '../constants';

/** The masthead bell on every page (prototype): unread count, rings while there is any. */
export function NotificationBell() {
  const navigate = useNavigate();
  const { data: inbox } = useInboxSummaryQuery(undefined);
  const badge = inbox?.badge ?? 0;
  return (
    <BaseIconButton
      icon="pi pi-bell"
      size="lg"
      round
      onClick={() => void navigate('/inbox/notifications')}
      aria-label={badge > 0 ? SHELL_TEXT.bell.unread(badge) : SHELL_TEXT.bell.notifications}
      title={SHELL_TEXT.bell.notifications}
      className={cn(badge > 0 && 'animate-bell-ring border-accent text-accent motion-reduce:animate-none')}
    >
      {badge > 0 && (
        <span className="absolute -top-0.75 -right-0.75 h-4 min-w-4 rounded-full bg-accent px-0.75 text-center text-[10px] leading-4 font-bold text-on-accent">
          {badge}
        </span>
      )}
    </BaseIconButton>
  );
}
